import * as types from './mutation-types'

export const loadTaskMilestones = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('milestone-categories/collections', data).then((response) => {
            commit(types.ADD_TASK_MILESTONES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadProjectMilestones = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('milestone-categories/project/'+id+'/collections').then((response) => {
            commit(types.ADD_PROJECT_MILESTONES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateTaskMilestone = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put('milestone-categories/' + data.id + '/update', data).then((response) => {
            commit(types.UPDATE_TASK_MILESTONE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createTaskMilestone = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('milestone-categories/store', data).then((response) => {
            commit(types.ADD_TASK_MILESTONE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const deleteTaskMilestone = ({ commit }, id) => {

    return new Promise((resolve, reject) => {
        window.axios.delete('milestone-categories/' + id + '/delete').then((response) => {
            commit(types.DESTROY_TASK_MILESTONE, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

